export default __webpack_public_path__ + "static/media/arrowForward.5c959687.svg";